import Decimal from 'decimal.js';
Decimal.set({
  precision: 50
});
/**
 * 精确的数值加法
 * @param num1
 * @param nums
 * @returns
 */

export function numberAdd(num1) {
  var d = new Decimal(num1);

  for (var _len = arguments.length, nums = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    nums[_key - 1] = arguments[_key];
  }

  nums.forEach(function (num) {
    d = d.add(num);
  });
  return d.toString();
}
/**
 * 精确的数值减法
 * @param num1
 * @param nums
 * @returns
 */

export function numberSub(num1) {
  var d = new Decimal(num1);

  for (var _len2 = arguments.length, nums = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    nums[_key2 - 1] = arguments[_key2];
  }

  nums.forEach(function (num) {
    d = d.sub(num);
  });
  return d.toString();
}
/**
 * 精确的数值乘法
 * @param num1
 * @param nums
 * @returns
 */

export function numberMul(num1) {
  var d = new Decimal(num1);

  for (var _len3 = arguments.length, nums = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    nums[_key3 - 1] = arguments[_key3];
  }

  nums.forEach(function (num) {
    d = d.mul(num);
  });
  return d.toString();
}
/**
 * 精确的数值除法
 * @param num1
 * @param nums
 * @returns
 */

export function numberDiv(num1) {
  var d = new Decimal(num1);

  for (var _len4 = arguments.length, nums = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    nums[_key4 - 1] = arguments[_key4];
  }

  nums.forEach(function (num) {
    d = d.div(num);
  });
  return d.toString();
}